import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  TASK_CATEGORY_LIST: 'task-task-category'
}

const routes = [
  {
    path: 'task-category/',
    name: ROUTES.TASK_CATEGORY_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['tasks_taskcategory_list'],
      requiresAuth: true
    },
    component: () => import('./TaskCategoryList.vue')
  }
]

export { routes, ROUTES }
